import React from 'react';
import { ExpeditedCheckoutHeaderContainer, Icon, CloseAction } from './ExpeditedCheckoutHeader.Styled';
export const ExpeditedCheckoutHeader = (props) => {
    const { onExit, logoComponent, hideExitButton } = props;
    return (React.createElement(ExpeditedCheckoutHeaderContainer, null,
        logoComponent,
        !hideExitButton && React.createElement(CloseAction, { onClick: () => onExit && onExit() },
            React.createElement(Icon, { icon: "menu close_big" }))));
};
//# sourceMappingURL=ExpeditedCheckoutHeader.js.map